import React, { useEffect, useState } from "react";
import "./Registration.css";
import {
  Button,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap";
import { toast } from "react-toastify";
import axios from "axios";
import BaseUrl from "../../base-api";
import { useNavigate } from "react-router-dom";
import moment from "moment";
const Registration = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("");
  const [payment, setPayment] = useState(false);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [timer, setTimer] = useState(0);
  const resendDelay = 60;
  const [lastDate, setLastDate] = useState('');
  const today = moment().startOf('day');
  const [formData, setFormData] = useState({
    candidateName: "",
    email: "",
    fatherName: "",
    mobileNumber: "",
    whatsappNumber: "",
    dob: "",
    referenceCode: "",
  });


  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer(prevTimer => prevTimer - 1);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);


  const [errors, setErrors] = useState({});

  useEffect(() => {
    axios.get(`${BaseUrl}/reg/registration`).catch((error) => {

    });
    setLastDate(moment('2025-07-31', 'YYYY-MM-DD'));

  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleOtpChange = (event) => {
    setOtp(event.target.value);
  };

  const validateMobileNumber = () => {
    const mobilePattern = /^[0-9]{10}$/;
    return mobilePattern.test(formData.mobileNumber);
  };
  const validateWhatsappNumber = () => {
    const mobilePattern = /^[0-9]{10}$/;
    return mobilePattern.test(formData.whatsappNumber);
  };












  const validateFieldsForOtp = () => {
    const { candidateName, email, fatherName } = formData;

    // Include reference code validation only if the reference code is entered

    return (
      candidateName &&
      email &&
      fatherName &&
      validateMobileNumber() &&
      validateWhatsappNumber()

    );
  };

  const registration = async (event) => {
    event.preventDefault();

    try {
      setIsLoading(true);
      setLoadingMessage("Saving your details....");
      const response = await axios.post(`${BaseUrl}/reg/registration`, {
        ...formData,
        otp,
      });
      if (response.status === 200) {
        toast.success(response.data.message, {
          className: "toast-large",
          position: "top-center",
        });
        setLoadingMessage("Waiting for payment confirmation....");
        navigate("/login")

      } else {
        toast.error(response.data.message, { position: "top-center" });
      }
    } catch (error) {
      toast.error(error.response.data.message, { position: "top-center" });
    }
  };

  const sendOtp = async () => {
    if (validateFieldsForOtp()) {
      try {
        const response = await axios.post(`${BaseUrl}/notification/sendOtp`, {
          mobileNumber: formData.mobileNumber,
          email: formData.email,
          referenceCode: formData.referenceCode
        });
        if (response.status === 200) {
          toast.success(response.data.message);
          setIsOtpSent(true);
          setTimer(resendDelay);
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        console.log(error)

        toast.error(error.response.data.message);
      }
    } else {
      toast.error("Please fill out all fields correctly before proceeding further.");
    }
  };

  const validateFields = (event) => {
    event.preventDefault();
    const { mobileNumber, referenceCode, ...otherFields } = formData;

    // Check if all fields are filled
    const allFieldsFilled = Object.values(otherFields).every(
      (value) => value !== ""
    );

    // Check if mobile number is valid
    const mobileNumberValid = validateMobileNumber();

    // Check if reference code is valid


    if (!allFieldsFilled) {
      toast.error("Kindly fill all the required details", {
        position: "bottom-center",
      });
    } else if (!mobileNumberValid) {
      toast.error("Mobile number must be exactly 10 digits", {
        position: "bottom-center",
      });
    } else {
      // All validations passed, proceed with registration
      registration(event);
    }
  };


  return (
    <>
      <Container
        className="py-3 border round mt-5"
        style={{
          width: "75%",
          backgroundColor: "#f6f5f591",
          boxShadow:
            "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
          borderRadius: "7px",
        }}
      >
        <h3 className="text-center" style={{ color: "black" }}>
          Registration for Online Skill Development Courses
        </h3>
        <hr />
        {lastDate && lastDate.isSameOrBefore(today) ? <div className="text-center p-4" style={{ color: 'red' }}>The last date for admissions is over. We thank all learners for their interest in these courses. Stay connected with us for updates on future admissions. For any queries, please visit website on regular basis.</div> :
          <Form onSubmit={validateFields} style={{ color: "grey" }} id="">
            <Row>
              <Col md={6}>
                <FormGroup className="m-2">
                  <Label for="candidateName">Candidate/Learner Name</Label>
                  <Input
                    id="candidateName"
                    name="candidateName"
                    onChange={handleChange}
                    value={formData.candidateName}
                    placeholder="Name will appear on Final Certificate"
                    type="text"
                    disabled={isOtpSent}
                  />
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup className="m-2">
                  <Label for="fatherName">Father's Name</Label>
                  <Input
                    id="fatherName"
                    name="fatherName"
                    placeholder="Enter your Father's Name"
                    type="text"
                    onChange={handleChange}
                    value={formData.fatherName}
                    disabled={isOtpSent}
                  />
                </FormGroup>
              </Col>
              {/* </Row>

          <Row> */}
              <Col md={6}>
                <FormGroup className="m-2">
                  <Label for="email">Email ID</Label>
                  <Input
                    id="email"
                    name="email"
                    placeholder="Enter your Email ID"
                    type="email"
                    onChange={handleChange}
                    value={formData.email}
                    disabled={isOtpSent}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup className="m-2">
                  <Label for="mobileNumber">Date of Birth</Label>
                  <Input
                    id="dob"
                    type="date"
                    name="dob"
                    placeholder="Select D.O.B."
                    onChange={handleChange}
                    value={formData.dob}
                    disabled={isOtpSent}
                    max={new Date().toISOString().split('T')[0]}
                    onKeyDown={(e) => e.preventDefault()}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup className="m-2">
                  <Label for="mobileNumber">Mobile Number</Label>
                  <Input
                    id="mobileNumber"
                    maxLength="10"
                    name="mobileNumber"
                    placeholder="Enter your Mobile Number"
                    type="text"
                    onChange={handleChange}
                    value={formData.mobileNumber}
                    disabled={isOtpSent}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup className="m-2">
                  <Label for="whatsappNumber">Whatsapp Number</Label>
                  <Input
                    id="whatsappNumber"
                    maxLength="10"
                    name="whatsappNumber"
                    placeholder="Enter your Whatsapp Number"
                    type="text"
                    onChange={handleChange}
                    value={formData.whatsappNumber}
                    disabled={isOtpSent}
                  />
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup className="m-2">
                  <Label htmlFor="reference">
                    Reference Code
                    <span style={{ fontSize: 'small' }}> (Only for Promotional Partners)</span>
                  </Label>
                  <Input
                    id="referenceCode"

                    name="referenceCode"
                    placeholder="Enter Reference Code"
                    type="text"
                    onChange={handleChange}
                    value={formData.referenceCode}

                  />
                </FormGroup>
              </Col>

            </Row>

            {isOtpSent && (
              <Row className="justify-content-center">
                <Col md={4}>
                  <FormGroup className="m-2">
                    <Label for="otp">Enter OTP</Label>
                    <Input
                      id="otp"
                      name="otp"
                      placeholder="Enter the OTP sent to your mobile"
                      type="text"
                      onChange={handleOtpChange}
                      value={otp}
                    />
                  </FormGroup>
                </Col>
              </Row>
            )}

            <div className="text-center">
              {!isOtpSent && (
                <Button color="primary" type="button" onClick={sendOtp}>
                  Proceed
                </Button>
              )}
              {isOtpSent && (
                <>
                  <Button color="success" type="submit" className="me-3">
                    Register
                  </Button>

                  <Button color="danger" onClick={sendOtp} disabled={timer > 0}>
                    Resend OTP {timer > 0 && `(${timer})`}
                  </Button>
                </>
              )}
            </div>
          </Form>}
      </Container>
    </>
  );
};

export default Registration;
